module.exports = __webpack_public_path__ + "static/media/star-yellow.fac948dc.svg";